import React from 'react';
import { ClosableMenuItem } from '@uplift/ui-v2';
import { ListItemIcon, Radio, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { PracticeStatesStatusFilterValue } from './PracticeStatesStatusFilter.types';

const useStyles = makeStyles()(theme => ({
  root: {
    padding: theme.spacing(0, 2, 0, 0.5),
  },
  icon: {
    minWidth: 'auto',
  },
}));

export type PracticeStatesStatusFilterItemProps = {
  label: string;
  value: PracticeStatesStatusFilterValue;
  selectedValue: PracticeStatesStatusFilterValue;
  setValue: (val: PracticeStatesStatusFilterValue) => void;
};

export const PracticeStatesStatusFilterItem: React.FC<PracticeStatesStatusFilterItemProps> = ({ label, selectedValue, value, setValue }) => {
  const { classes } = useStyles();

  return (
    <ClosableMenuItem dense onClick={() => setValue(value)} className={classes.root}>
      <ListItemIcon className={classes.icon}>
        <Radio checked={selectedValue === value} />
      </ListItemIcon>
      <Typography color="textPrimary">{label}</Typography>
    </ClosableMenuItem>
  );
};
